import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "112vh",
    "& .MuiButtonBase-root": {
      textTransform: "capitalize",
      "&:hover": {
        // backgroundColor: theme.palette.custom.main,
        color: "#000",
      },
    },
    overflow: "auto",
  },
  // loginContainer: {
  // background: "rgba(255, 255, 207, 0)", 
  // // backdropFilter: "blur(10px)",             
  // WebkitBackdropFilter: "blur(10px)",       
  // border: "1px solid rgba(255, 255, 255, 0.3)",
  //   // boxShadow:
  //   // "0px 0px 4px rgba(0, 0, 0, 0.04), 0px 8px 16px rgba(0, 0, 0, 0.08)",
  //   // borderRadius: 20,
  //   display: "flex",
  //   alignItems: "center",
  //   flexDirection: "column",
  //   margin: "0px 50px",
  //   padding: "40px 50px",
  //   borderRadius:"10px"
  // },
  loginContainer: {
  background: "#fdfdfd",
  borderRadius: "20px",
  boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
  border: "1px solid rgba(0,0,0,0.06)",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  padding: "40px",
  margin: "0 auto",
  maxWidth: "420px",
  width: "100%",
  height:"100vh"
},
  // loginWrapper: {
  //   alignItems: "center",
  // },
  // imgContainer: {
  //   alignSelf: "center",
  // },
  gridFields: {
    width: "100%",
    paddingBlock: 8,
  },
  logo: {
    width: 90,
    height: 90,
    objectFit: "cover",
  },
  forgotPassWordLabel: {
    alignSelf: "center",
  },
  forgotLabel: {
    cursor: "pointer",
    opacity: 0.8,
    fontSize: 30,
    paddingBlock: 4,
  },
  fadetext:{
  color:"gray",
  fontWeight:"400 !important"
  },
  // password: {
  //   "&.MuiSvgIcon-root": {
  //     cursor: "pointer",
  //   },
  // },
  loginPageImage: {
    width: "100%",
    height: "112vh",
    objectFit: "cover",
    position: "relative",
    filter:"brightness(0.8)",
  },
  membersbutton:{
    background:"white"
  },

  loginImageContainer: {
    position: "relative",
  },
  overlayText: {
    position: "absolute",
    display: "flex",
    justifyContent: "center",
    alignItems: "start",
    flexDirection: "column",
   top: 50,
    left: 0,
    bottom: 50,
    width: "100%",
    //backgroundColor: "rgba(0, 0, 0, 0.6)",
    color: "white",
    padding: "10px",
  },
  gridContainer: {
   height: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
    
         
  },
 
loginbanner: {
  position: "relative",
  width: "90%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
},

bannerImg: {
  width: "100%",
  height: "100%",
  objectFit: "cover",
  borderRadius: "20px",
},

bannerTextWrapper: {
  position: "absolute",
  top: "60px",
  left: "80px",
  zIndex: 2,
},

bannerText: {
  fontFamily: "'Poppins', sans-serif !important",
  fontWeight: "800 !important",
  fontSize: "75px !important",
  lineHeight: "89% !important",
  letterSpacing: "-0.06em !important",
  color: "#000 !important",
  margin: "0 !important",
  padding: "0 !important",
  textTransform: "none",
  whiteSpace: "nowrap",

  "&.MuiTypography-root": {
    fontFamily: "'Poppins', sans-serif !important",
    fontWeight: "800 !important",
    fontSize: "75px !important",
    lineHeight: "89% !important",
    letterSpacing: "-0.06em !important",
    margin: 0,
  },
},



  gridItem: {
    flex: "1",
    bottom:0,
   
  },
  boldertext:{
//  fontWeight:"bold",
color:"#000",
marginTop:"10px !important"
 
  },
  boldText: {
    fontSize: "52px",
    fontWeight: "bold",
    color:"#000 !important",
    marginLeft:"10px !important"
  },
  highlightText: {
    color: "#000000",
    marginLeft:"2%",
    fontWeight:"bold"
  },
  highlightTextBig: {
    color: "#c4c4c4",
    fontSize: "52px",
  },

whiteBgBlackText_WhiteBorder: {
  width: "100%",

  "& .MuiOutlinedInput-root": {
    height: "52px",
    borderRadius: "14px",
    background: "#fff",

    "& fieldset": {
      border: "1px solid #D9D9D9",
    },

    "&:hover fieldset": {
      border: "1px solid #D9D9D9",
    },

    "&.Mui-focused fieldset": {
      border: "1px solid #D9D9D9",
    },
  },

  "& .MuiInputBase-input": {
    padding: "14px 10px",
    fontSize: "16px",
    fontFamily: "Poppins, sans-serif",
    color: "#222",
  },

  "& .MuiInputAdornment-root svg": {
    color: "#8C8C8C",
    fontSize: "22px",
  },

  "& .MuiFormHelperText-root": {
    marginLeft: 0,
  },
},


inputLabel: {
  color: "#5F5F5F",
  fontSize: "15px",
  fontWeight: 500,
  marginBottom: "8px",
  fontFamily: "Poppins, sans-serif",
},

password: {
  cursor: "pointer",

  "& svg": {
    color: "#7A7A7A",
    fontSize: "22px",
  },
},

loginButton: {
  marginTop: "18px !important",
  height: "56px",
  borderRadius: "30px !important",
  background: "#233950 !important",
  color: "#fff !important",
  textTransform: "none !important",
  fontSize: "14px !important",
  fontWeight: "600 !important",
  fontFamily: "Poppins, sans-serif !important",

  "&:hover": {
    background: "#1C2C3C !important",
  },
},



}));

export default useStyles;
